import { render, staticRenderFns } from "./ItemSelect.vue?vue&type=template&id=6cd065f4&"
import script from "./ItemSelect.vue?vue&type=script&lang=js&"
export * from "./ItemSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp7.4.1\\htdocs\\e2e-invoicing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cd065f4')) {
      api.createRecord('6cd065f4', component.options)
    } else {
      api.reload('6cd065f4', component.options)
    }
    module.hot.accept("./ItemSelect.vue?vue&type=template&id=6cd065f4&", function () {
      api.rerender('6cd065f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/estimates/ItemSelect.vue"
export default component.exports